import './component.css'

const Image = ({ image, caption, previous, next }) => {
  return (
    <div className="container">
      <div className="row g-0">
        <div className="col">
          <button className='image_button' onClick={previous} >
            &#10094;
          </button>
        </div>
        <div className="col-8">
          <img className="img-fluid" src={image} alt={caption}/>
        </div>
        <div className="col">
          <button className='image_button' onClick={next} >&#10095;</button>
        </div>
      </div>
      <figcaption>{caption}</figcaption>
    </div>
  );
};

export default Image;
